// src/pages/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import About from '../components/About';
// import Education from '../components/Education';
// import Skills from '../components/Skills';
import Experiences from '../components/Experiences';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import { Helmet } from 'react-helmet-async';

export default function Home() {
  return (
    <>
        <Helmet>
            <title>Nikhil Goyal</title>
            <meta
            name="description"
            content="Nikhil Goyal is an AI researcher and developer at IIT Gandhinagar specializing in NLP, computer vision, OCR, machine learning, on-device AI, and healthcare AI."
            />
            <meta name="keywords" content="Nikhil Goyal, IIT Gandhinagar, IITGN, AI researcher, machine learning engineer, NLP researcher, computer vision researcher, OCR, on-device AI, healthcare AI, deep learning, AI developer, portfolio" />
            <meta name="author" content="Nikhil Goyal" />
            <meta name="robots" content="index, follow, max-image-preview:large" />
            <link rel="canonical" href="https://nikhil-405.github.io/" />
            <meta property="og:title" content="Nikhil Goyal | AI Researcher & Developer | IIT Gandhinagar" />
            <meta property="og:description" content="AI researcher and developer at IIT Gandhinagar working across NLP, computer vision, OCR, machine learning, and healthcare AI." />
            <meta property="og:url" content="https://nikhil-405.github.io/" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Nikhil Goyal Portfolio" />
            <meta property="og:locale" content="en_US" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Nikhil Goyal | AI Researcher & Developer | IIT Gandhinagar" />
            <meta name="twitter:description" content="AI researcher and developer at IIT Gandhinagar building work in NLP, computer vision, OCR, machine learning, and healthcare AI." />
            <meta name="twitter:creator" content="@nikhil_405" />
            <script type="application/ld+json">
              {JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'Person',
                name: 'Nikhil Goyal',
                jobTitle: 'AI Researcher & Developer',
                url: 'https://nikhil-405.github.io/',
                worksFor: {
                  '@type': 'Organization',
                  name: 'Indian Institute of Technology Gandhinagar',
                  alternateName: 'IIT Gandhinagar'
                },
                alumniOf: {
                  '@type': 'Organization',
                  name: 'Indian Institute of Technology Gandhinagar'
                },
                knowsAbout: [
                  'Artificial Intelligence',
                  'Machine Learning',
                  'Natural Language Processing',
                  'Computer Vision',
                  'OCR',
                  'Healthcare AI',
                  'Deep Learning'
                ],
                sameAs: [
                  'https://github.com/nikhil-405',
                  'https://linkedin.com/in/nikhil-4o5'
                ]
              })}
            </script>
        </Helmet>
      <header>
        <Hero />
      </header>

      <main>
        <section id="about" aria-labelledby="about-heading">
          <h2 id="about-heading">About Me</h2>
          <About />
        </section>

        {/* 
        <section id="education" aria-labelledby="education-heading">
          <h2 id="education-heading">Education</h2>
          <Education />
        </section>

        <section id="skills" aria-labelledby="skills-heading">
          <h2 id="skills-heading">Skills</h2>
          <Skills />
        </section>
        */}

        <section id="experiences" aria-labelledby="experiences-heading">
          <div className="section-header">
            <h2 id="experiences-heading">Experience</h2>
            <Link to="/experience" className="view-all-inline">
              View All →
            </Link>
          </div>
          <Experiences />
        </section>

        <section id="projects" aria-labelledby="projects-heading">
          <div className="section-header">
            <h2 id="projects-heading">Projects</h2>
            <Link to="/projects" className="view-all-inline">
              View All →
            </Link>
          </div>
          <Projects />
        </section>

        {/* 
        <section id="certifications" aria-labelledby="certifications-heading">
          <h2 id="certifications-heading">Certifications</h2>
          <Certifications />
        </section>
        */}

        <section id="contact" aria-labelledby="contact-heading">
          <h2 id="contact-heading">Contact</h2>
          <Contact />
        </section>
      </main>

      <footer>
        <p style={{ textAlign: 'center', padding: '2rem 0', color: '#777' }}>
          © {new Date().getFullYear()} Nikhil Goyal. All rights reserved.
        </p>
      </footer>
    </>
  );
}
